export default __webpack_public_path__ + "static/media/InsideHeart_02.258e2a62.png";